import * as Actions from './csv-import.actions';
import { ImportStatus } from '../../components/csv-import/data/types/import-status';
import { ImportTypesValues } from '../../components/csv-import/data/types/import-type';

const namespace = 'csvImport';

const initialState = ImportTypesValues.reduce(
  (acc, value) => ({
    ...acc,
    [value]: {},
  }),
  {},
);

const csvImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.IMPORT_PROCESS_REQUESTED:
      return {
        ...state,
        [action.payload.importType]: {
          ...action.payload,
          status: ImportStatus.ACTIVE,
        },
      };
    case Actions.UPDATE_IMPORT_STATUS:
      return {
        ...state,
        [action.payload.importType]: {
          ...state[action.payload.importType],
          ...action.payload,
        },
      };
    case Actions.ADD_METADATA_TO_IMPORT:
      return {
        ...state,
        [action.payload.importType]: {
          ...state[action.payload.importType],
          metadata: {
            ...(state[action.payload.importType].metadata ?? {}),
            ...action.payload.metadata,
          },
        },
      };
    case Actions.CLEAR_IMPORT_STATUS:
      return {
        ...state,
        [action.payload.importType]: {},
      };
    default:
      return state;
  }
};

export { csvImportReducer, namespace };
